<!-- src/view/layout/extras/dropdown/NotificationDropdown.vue -->
<template>
    <div class="topbar-item">
        <b-dropdown id="kt_topbar_notifications" variant="link" toggle-class="topbar-item text-decoration-none" no-caret
            right no-flip boundary="window" class="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
            menu-class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg rounded-lg shadow-lg"
            ref="dropdown">
            <template v-slot:button-content>
                <div class="position-relative">
                    <span class="svg-icon svg-icon-3x">
                        <inline-svg src="/media/logos/notification.svg" />
                    </span>

                    <span v-if="unreadNotificationCount > 0"
                        class="label label-rounded label-sm position-absolute d-flex align-items-center justify-content-center animate__animated animate__heartBeat animate__infinite"
                        style="top: -6px; right: -10px; min-width: 24px; height: 24px; font-size: 0.8rem; background-color: #4554a2; color: white; border: 3px solid #e35a9c; box-shadow: 0 0 12px rgba(79,70,229,0.5); z-index: 10; border-radius: 50%;">
                        {{ unreadNotificationCount > 5 ? '5+' : unreadNotificationCount }}
                    </span>

                    <span class="pulse-ring" style="border-color: #4554a2;"></span>
                </div>
            </template>

            <div class="dropdown-menu-lg" style="width: 380px;">
                <div class="d-flex flex-column h-100 bg-white rounded-lg overflow-hidden">

                    <div class="d-flex align-items-center justify-content-between p-5 text-white font-weight-bolder"
                        style="background: linear-gradient(135deg, #4554a2 0%, #4554a2 100%);">
                        <h5 class="m-0">اعلان‌ها</h5>
                        <span v-if="unreadNotificationCount">{{ unreadNotificationCount }} جدید</span>
                    </div>

                    <div class="flex-grow-1 overflow-auto" style="max-height: 460px;">
                        <div v-if="!notifications.length" class="text-center py-12 text-muted font-size-lg">
                            اعلانی وجود ندارد
                        </div>

                        <div v-for="(n, i) in notifications.slice(0, 15)" :key="n.id"
                            class="d-flex align-items-start p-4 cursor-pointer position-relative hoverable transition-all"
                            :class="{ 'bg-light-primary': !n.seen_at }" @click="goTo(n.id)">
                            <div v-if="!n.seen_at" class="position-absolute right-0 top-0 bottom-0"
                                style="width: 4px; background-color: #4554a2; border-radius: 0 4px 4px 0;"></div>

                            <div class="symbol symbol-45 symbol-light flex-shrink-0 mr-4">
                                <span class="symbol-label">
                                    <i :class="icon(n.type)" class="text-white"></i>
                                </span>
                            </div>

                            <div class="d-flex flex-column flex-grow-1 pr-3">
                                <div class="font-weight-bolder text-dark-75 mb-1">{{ n.title }}</div>
                                <div class="text-dark-50 font-size-sm mb-2" style="line-height: 1.5;">
                                    {{ truncate(n.message, 80) }}
                                </div>

                                <div class="d-flex align-items-center font-size-xs">
                                    <svg v-if="n.seen_at" width="17" height="17" viewBox="0 0 256 256" class="mr-2">
                                        <path
                                            d="M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Z"
                                            fill="#4F46E5" opacity="0.7" />
                                        <path
                                            d="M245.71,74.39a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
                                            fill="#4F46E5" />
                                    </svg>
                                    <i v-else class="far fa-clock text-muted mr-2"></i>

                                    <span
                                        :class="{ 'text-primary font-weight-bold': n.seen_at, 'text-muted': !n.seen_at }">
                                        {{ format(n.created_at) }}
                                    </span>
                                </div>
                            </div>

                            <div v-if="!n.seen_at" class="mt-2">
                                <span class="symbol-badge bg-primary" style="width: 10px; height: 10px;"></span>
                            </div>

                            <div v-if="i < 14" class="position-absolute bottom-0 left-4 right-4"
                                style="height: 1px; background: linear-gradient(90deg, transparent, #e5e7eb, transparent);">
                            </div>
                        </div>
                    </div>

                    <div class="border-top p-4 text-center bg-light">
                        <router-link :to="{ name: 'notifications' }"
                            class="btn btn-primary font-weight-bold px-6 py-3 shadow-sm rounded view-all-btn"
                            @click.native="$refs.dropdown.hide()">
                            مشاهده همه اعلان‌ها
                        </router-link>
                    </div>

                </div>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "NotificationDropdown",

    mounted() {
        this.$store.dispatch("notification/fetchNotifications");

        this.interval = setInterval(() => {
            this.$store.dispatch("notification/fetchNotifications");
        }, 60000);
    },

    beforeDestroy() {
        if (this.interval) clearInterval(this.interval);
    },

    computed: {
        ...mapGetters("notification", ["notifications", "unreadNotificationCount"]),
    },

    methods: {
        goTo(id) {
            this.$refs.dropdown.hide();
            this.$router.push({ name: "notification-show", params: { id } }).catch(() => { });
        },

        truncate(text, len = 80) {
            if (!text) return "";
            return text.length > len ? text.substr(0, len).trim() + "..." : text;
        },

        format(date) {
            return new Date(date).toLocaleString("fa-IR", {
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },

        icon(type) {
            const map = {
                success: "flaticon2-check-mark text-success",
                info: "flaticon2-information text-info",
                warning: "flaticon2-warning text-warning",
                error: "flaticon2-delete text-danger",
                message: "flaticon2-chat-1 text-primary"
            };
            return map[type] || "flaticon2-bell text-primary";
        }
    }
};
</script>

<style scoped>
.view-all-btn {
    background: #4554a2 !important;
    border: none !important;
    transition: all 0.25s ease !important;
}

.view-all-btn:hover {
    background: #4338ca !important;
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(79, 70, 229, 0.4) !important;
}

.pulse-ring {
    top: -6px;
    left: -6px;
    right: -6px;
    bottom: -6px;
    border: 4px solid #e35a9c;
    border-radius: 50%;
}
</style>